import { createContext } from 'react';
import PocketBase from 'pocketbase';

const PocketBaseContext = createContext<PocketBase | null>(null);

export default PocketBaseContext;
